import { render, staticRenderFns } from "./cetak_tanda_terima.vue?vue&type=template&id=1fa2db3b&"
import script from "./cetak_tanda_terima.vue?vue&type=script&lang=js&"
export * from "./cetak_tanda_terima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports